module.exports = __webpack_public_path__ + "static/11-73d98fcb0fe08ee65391b4475d7b6a59.jpg";